import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslatePipe } from '@ngx-translate/core';
import { CreateOpportunityComponent } from '../../../dialogs/common/create-opportunity/create-opportunity.component';
import { InformationLinkUnlinkComponent } from '../../../dialogs/common/information-link-unlink/information-link-unlink.component';
import { MatDividerModule } from '@angular/material/divider';

enum OpportunityOptionId {
  CREATE_NEW = 'createNew',
  LINK_UNLINK = 'linkUnlink'
}

@Component({
  selector: 'app-file-opportunity',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    TranslatePipe,
    CreateOpportunityComponent,
    InformationLinkUnlinkComponent,
    MatDividerModule
  ],
  templateUrl: './file-opportunity.component.html',
  styleUrl: './file-opportunity.component.scss'
})
export class FileOpportunityComponent implements OnInit {
  @Input() isCreateDisabled: boolean = false;
  @Input() isLinkUnlinkDisabled: boolean = false;
  @Input() isCollaborativeReadOnly: boolean = false;

  @Output() cancel = new EventEmitter<void>();
 

  selectedOptionId: string = OpportunityOptionId.CREATE_NEW;
  opportunityOptionId = OpportunityOptionId;

  ngOnInit(): void {
    this.selectedOptionId = this.isCreateDisabled ? OpportunityOptionId.LINK_UNLINK : OpportunityOptionId.CREATE_NEW;
  }
 
  selectOption(optionId: string, isDisabled: boolean): void {
    if (isDisabled) {
      return;
    }

    this.selectedOptionId = optionId;
  }

  getSelectedOptionLabel(): string {
    return this.selectedOptionId === OpportunityOptionId.CREATE_NEW
      ? 'CREATE_NEW'
      : 'INFORMATION_LINK_UNLINK';
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
